import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { message } from "antd";

import {
  Spacer,
  boxContainer,
  inputFields,
  recommender,
  Buttons,
  GetProPopup,
  questionnaireComponents,
} from "../../components";

import CircleContainer from "./circle-container";

import { Utils, UtilityArrays } from "../../config";

import "./styles.css";

function RecommendersQualifications() {
  const navigate = useNavigate();

  const profileData = useSelector((state) => state?.profile?.user);

  const [curriculumValues, setCurriculumValues] = useState([
    { subject: null, grade: null },
    { subject: null, grade: null },
    { subject: null, grade: null },
  ]);
  const [toefl, setToefl] = useState("");
  const [ielts, setIelts] = useState("");
  const [satAll, setSatAll] = useState("");
  const [satEnglish, setSatEnglish] = useState("");
  const [satMath, setSatMath] = useState("");
  const [showSatMathEnglish, setShowSatMathEnglish] = useState(false);

  const selectedSubjects = curriculumValues
    .map((item) => item.subject)
    .filter((subject) => subject !== null);

  const getFilteredSubjects = (currentIndex) => {
    return UtilityArrays?.curriculumSubjects.filter(
      (subject) =>
        !selectedSubjects.includes(subject) ||
        curriculumValues[currentIndex].subject === subject
    );
  };

  const handleNext = () => {
    if (!profileData?.freeUser) {
      if (
        (satEnglish || satMath || satAll) &&
        parseInt(satEnglish) + parseInt(satMath) !== parseInt(satAll)
      ) {
        message.error(
          "Your total SAT score does not match the total SAT score"
        );
      } else if (
        curriculumValues.some((item) => !item.subject || !item.grade)
      ) {
        message.error("Please fill all the required fields in grades");
      } else {
        navigate("/recommender/preferences", {
          state: {
            grades: curriculumValues,
            toefl: toefl ? toefl : "0",
            ielts: ielts ? ielts : "0",
            satAll: satAll ? satAll : "0",
            satEnglish: satEnglish ? satEnglish : "0",
            satMath: satMath ? satMath : "0",
          },
        });
      }
    }
  };

  const addCurriculum = () => {
    if (curriculumValues.length >= 10) {
      message.error("You can only add up to 10 grades.");
      return;
    }

    setCurriculumValues([
      ...curriculumValues,
      {
        subject: null,
        grade: null,
      },
    ]);
  };

  const removeCurriculum = (index) => {
    if (index < 3) {
      message.error("The first three grades cannot be removed.");
      return;
    }

    const updatedCurriculumValues = curriculumValues.filter(
      (_, i) => i !== index
    );
    setCurriculumValues(updatedCurriculumValues);
  };

  const handleCurriculumChange = (index, field, value) => {
    const updatedCurriculumValues = [...curriculumValues];
    updatedCurriculumValues[index][field] = value;
    setCurriculumValues(updatedCurriculumValues);
  };

  return (
    <div className="relative text-black">
      {profileData?.freeUser && (
        <div className="absolute top-[100px] left-[35%] z-[10]">
          <GetProPopup />
        </div>
      )}
      <boxContainer.LiteBoxContainer>
        <div
          className={`${profileData?.freeUser && "blur pointer-events-none"}`}
        >
          <CircleContainer page="qualifications" />
          <Spacer height={20} />
          <div>
            <div className="flex flex-col gap-3 ml-5">
              <div className="section-header">A Level Grades</div>
              {curriculumValues?.map((curriculum, index) => (
                <div className={`${index > 0 ? "mt-2" : ""} `} key={index}>
                  <div className="section-header flex justify-between items-center">
                    Grade {index + 1}
                    {index >= 3 && (
                      <Buttons.RedButton
                        size="small"
                        onClick={() => removeCurriculum(index)}
                      >
                        Remove
                      </Buttons.RedButton>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-x-7 gap-y-6">
                    <div>
                      <questionnaireComponents.QuestionnaireLabel
                        text="Subject"
                        required
                      />
                      <Spacer height={5} />

                      <inputFields.SelectDropdown
                        onChange={(e) =>
                          handleCurriculumChange(index, "subject", e)
                        }
                        items={Utils.filterArray(getFilteredSubjects(index))}
                        placeholder="Enter value"
                        value={curriculum?.subject}
                      />
                    </div>
                    <div>
                      <questionnaireComponents.QuestionnaireLabel
                        text={"Grade"}
                        required
                      />
                      <Spacer height={5} />
                      <inputFields.SelectDropdown
                        onChange={(e) =>
                          handleCurriculumChange(index, "grade", e)
                        }
                        items={Utils.filterArray(
                          UtilityArrays?.currculumGrade2
                        )}
                        placeholder="Enter value"
                        value={curriculum?.grade}
                      />
                    </div>
                  </div>
                </div>
              ))}
              {curriculumValues.length < 10 && (
                <div className="flex justify-end mt-6">
                  <Buttons.DefaultButton onClick={addCurriculum} size="medium">
                    + Add More
                  </Buttons.DefaultButton>
                </div>
              )}
            </div>
          </div>

          <div className="inputFieldContainer">
            <div>
              <recommender.RecommenderBoxLabel title="TOEFL Score" />
              <Spacer height={10} />
              <inputFields.DefaultInput
                disabled={profileData?.freeUser}
                placeholder="0-120"
                type="number"
                value={toefl}
                onChange={(e) => setToefl(e.target.value)}
              />
            </div>
            <div>
              <recommender.RecommenderBoxLabel title="IELTS Score" />
              <Spacer height={10} />
              <inputFields.DefaultInput
                disabled={profileData?.freeUser}
                placeholder="1-9"
                type="number"
                value={ielts}
                onChange={(e) => setIelts(e.target.value)}
              />
            </div>
            <div>
              <recommender.RecommenderBoxLabel title="SAT Score" />
              <Spacer height={10} />
              <inputFields.DefaultInput
                disabled={profileData?.freeUser}
                placeholder="0-1600"
                type="number"
                value={satAll}
                onChange={(e) => setSatAll(e.target.value)}
                onClick={() => setShowSatMathEnglish(true)}
              />
            </div>
            {showSatMathEnglish && (
              <>
                <div>
                  <recommender.RecommenderBoxLabel title="SAT (English)" />

                  <Spacer height={10} />
                  <inputFields.DefaultInput
                    disabled={profileData?.freeUser}
                    placeholder="0 - 800"
                    type="number"
                    value={satEnglish}
                    onChange={(e) => setSatEnglish(e.target.value)}
                  />
                </div>
                <div>
                  <recommender.RecommenderBoxLabel title="SAT (Math)" />
                  <Spacer height={10} />
                  <inputFields.DefaultInput
                    disabled={profileData?.freeUser}
                    placeholder="0 - 800"
                    type="number"
                    value={satMath}
                    onChange={(e) => setSatMath(e.target.value)}
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                disabled={profileData?.freeUser}
                onClick={handleNext}
                size="medium"
                width="full"
              >
                Continue
              </Buttons.DefaultButton>
            </div>
          </div>
        </div>
      </boxContainer.LiteBoxContainer>
    </div>
  );
}

export default RecommendersQualifications;
